module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMBAMAAACQIoDIAAAAD1BMVEX///////////9HcEz///9bnwQ6AAAABHRSTlO3Bn8AnxwJMgAAAEpJREFUCNclyNENgDAMA1EjdYBKbFBYIPUCCGX/mcgF//j05OXesnZeVJ1mvuSdh2LAO59Tbi60DIOVMEgWg2Qx2BkD7PQE/wzQH6y8Fbi9Pbb4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/funding_jolin/home/icon-arrow-white.png
// module id = mdIm
// module chunks = 1